import React from 'react'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { ColorExtractor } from 'react-color-extractor'

const styles = (theme: Theme) => ({
  errorMessage: {
    backgroundColor: theme.palette.common.white,
  },
  AppImg: {
    width: '100%',
    height: '100%',
    'object-fit': 'contain',
    backgroundColor: theme.palette.grey['200'],
    [theme.breakpoints.up('sm')]: {
      height: 466,
    },
  }
});

interface Props {
  error: boolean,
  getColors: (colors: any) => void,
  onError: (error: boolean) => void,
  image: string
}

type PropsWithStyles = Props & WithStyles<'errorMessage' | 'AppImg'>;

class Image extends React.Component<PropsWithStyles> {

  render() {
    const { classes } = this.props;
    return (  
      this.props.error || this.props.image === '' ? (
        <div className={classes.errorMessage}>
          <List>
            <ListItem>
              <ListItemIcon>
                  <ErrorOutlineIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Oops, we can't read that URL. Please download the image to your computer and upload it again." />
            </ListItem>
          </List>
          
        </div>
      ) : (
        <Box textAlign="center">
          <ColorExtractor 
            getColors={this.props.getColors} 
            onError={this.props.onError}
          >
            <img
              alt="Wideo Color Extractor Img"
              src={this.props.image}
              className={classes.AppImg}
            />
          </ColorExtractor>
        </Box>
      )
    );
  }

  }

  export default withStyles(styles)(Image);  